import { render, staticRenderFns } from "./GpsBasedCurrenciesModal.vue?vue&type=template&id=53675504"
import script from "./GpsBasedCurrenciesModal.vue?vue&type=script&lang=ts"
export * from "./GpsBasedCurrenciesModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports